import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import GoogleIcon from '@mui/icons-material/Google';
import FacebookIcon from '@mui/icons-material/Facebook';
import AppleIcon from '@mui/icons-material/Apple';
import MicrosoftIcon from '@mui/icons-material/Window';
import type { OAuthProviderId } from '../types';
import { initiateOAuthFlow } from '../services/oauth';

const providers: { id: OAuthProviderId; name: string; icon: React.ReactNode; color: string }[] = [
  { id: 'google', name: 'Google', icon: <GoogleIcon />, color: '#db4437' },
  { id: 'facebook', name: 'Facebook', icon: <FacebookIcon />, color: '#1877f2' },
  { id: 'microsoft', name: 'Microsoft', icon: <MicrosoftIcon />, color: '#00a4ef' },
  { id: 'apple', name: 'Apple', icon: <AppleIcon />, color: '#000000' },
];

export function OAuthButtons() {
  const handleOAuthClick = async (provider: OAuthProviderId) => {
    try {
      await initiateOAuthFlow(provider);
    } catch (error) {
      console.error(`OAuth ${provider} failed:`, error);
    }
  };

  return (
    <Stack spacing={1.5} sx={{ width: '100%' }}>
      <Divider>
        <Typography variant="body2" color="text.secondary">
          ou continue com
        </Typography>
      </Divider>
      {providers.map((provider) => (
        <Button
          key={provider.id}
          variant="outlined"
          fullWidth
          startIcon={provider.icon}
          onClick={() => handleOAuthClick(provider.id)}
          sx={{
            borderColor: 'divider',
            color: 'text.primary',
            '&:hover': {
              borderColor: provider.color,
              backgroundColor: `${provider.color}08`,
            },
          }}
        >
          {provider.name}
        </Button>
      ))}
    </Stack>
  );
}
